'use strict';

import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useFloating, offset, arrow } from '@floating-ui/react-dom';
import ClickAwayListener from 'react-click-away-listener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersSelectors, usersOperations } from '@/state/domains/users';

import { getHistory } from '@/history';

import Link from '@/views/common/Link';

import s from './styles.scss'
import d from '../styles.scss'

const sx = cn.bind(s);
const dx = cn.bind(d);

let timeoutId;

/*
<li
	className={ sx('menuItem', 'col', 'noHighlight') }
>
	<div className={ s.menuItemRow }>
		<div className={ s.listCell }>
			<FontAwesomeIcon icon='magnifying-glass' color='#444'/>
		</div>
		<div className={ s.listCell }>
			<label className={ s.label }>
				<input
					type='text'
					className={ s.searchUsers }
					value={ searchQ }
					onChange={ onSearchChange }
					autoFocus
				/>
			</label>
		</div>
	</div>
	{
		searched &&
		<div className={ s.searchResults }>
			{
				!!searchResults.length &&
				<table>
					<thead>
						<tr>
							<th>Username</th>
							<th>First Name</th>
							<th>Last Name</th>
						</tr>
					</thead>
					<tbody>
					{
						searchResults.map((u, i) => (
							<tr
								key={ i }
								className={ s.userRow }
								onClick={
									() => history.push(getUrl(u))
								}
							>
								<td>{ u.username }</td>
								<td>{ u.firstName }</td>
								<td>{ u.lastName }</td>
							</tr>
						))
					}
					</tbody>
				</table>
			}
			{
				!searchResults.length &&
				<div className={ s.noResults }>
					No Results
				</div>
			}
		</div>
	}
</li>*/

export default connect(
	(state, props) => ({
		pageId: appSelectors.getPageId(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		users: usersSelectors.getAllUsers(state, props),
		isUsersLoaded: appSelectors.isUsersLoaded(state, props),
	}),
	{
		getUsers: usersOperations.getUsers,
		setModalOpen: appOperations.setModalOpen,
		searchUsersReq: usersOperations.searchUsers,
		setUsersLoaded: appOperations.setUsersLoaded,
	}
)(
	({
		user,
		users,
		urlParams,
		pageId,
		setModalOpen,
		searchUsersReq,
		getUsers,
		isUsersLoaded,
		setUsersLoaded,
	}) => {

		const history = getHistory();

		const mounted = useRef(false);
		const arrowRef = useRef(null);

		useEffect(() => {
			mounted.current = true;

			return () => {
				mounted.current = false;
			};
		});

		useEffect(
			() => {
				if (!isUsersLoaded) {
					getUsers({}).then(r => setUsersLoaded());
				}
			},
			[]
		);

		const {
			x,
			y,
			reference,
			floating,
			strategy,
			update,
			middlewareData: {
				arrow: {
					x: arrowX,
					y: arrowY,
				} = {}
			},
		} = useFloating({
			placement: 'bottom-start',
			middleware: [
				offset(4),
				arrow({ element: arrowRef }),
			],
		});

		const [ menuOpen, setMenuOpen ] = useState(false);
		const [ searchQ, setSearchQ ] = useState('');
		const [ searched, setSearched ] = useState(false);
		const [ searchResults, setSearchResults ] = useState([]);

		const onSearchChange = e => {
			const { value } = e.target;
			setSearchQ(value);
			searchUsers(value);
		};

		const searchUsers = value => {
			
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(
				() => {
					searchUsersReq(value).then(r => {
						setSearched(true);
						setSearchResults(r.data.users);
					});
				},
				1000
			);
		};

		let getUrl;

		switch (pageId) {
			case 'daily-route':
				getUrl = u => `/user/${ u.username }/${ urlParams.date }/route`;
				break;
			default:
				getUrl = u => `/user/${ u.username }`;
		}

		return (
			<ClickAwayListener
				onClickAway={ () => {
					if (mounted.current) {
						setMenuOpen(false);
					}
				}}
			>
				<div className={ s.usersMenu }>
					<div
						className={ cn(dx('composite'), sx('btn')) }
						ref={ reference }
						onClick={
							() => {
								setMenuOpen(!menuOpen);
								update();
							}
						}
					>
						<label>Users</label>
						<div className={ d.rightIcon }>
							<FontAwesomeIcon icon='caret-down' />
						</div>
					</div>
					{
						menuOpen && (
							<div
								ref={ floating }
								style={{
									position: strategy,
									top: y ?? 0,
									left: x ?? 0,
									zIndex: 20,
								}}
							>
								<div
									ref={ arrowRef }
									className={ s.arrow }
									style={{
										position: strategy,
										top: arrowY ?? -4,
										left: arrowX ?? 0,
									}}
								/>
								<ul className={ s.menu } >
									<li className={ s.menuItem }>
										<Link to={{ pathname: '/users' }}>
											<div className={ s.listCell }>
												<FontAwesomeIcon icon='users' color='#444'/>
											</div>
											<div className={ s.listCell }>
												<label className={ s.label }>Users Page</label>
											</div>
										</Link>
									</li>
									<li>
										<div className={ s.searchResults }>
										{
											!!users.length &&
											<table>
												<thead>
													<tr>
														<th>Last Name</th>
														<th>First Name</th>
														<th>Username</th>
													</tr>
												</thead>
												<tbody>
												{
													users.sort((a, b) => a.lastName.localeCompare(b.lastName)).map((u, i) => (
														<tr
															key={ i }
															className={ s.userRow }
															onClick={
																() => history.push(getUrl(u))
															}
														>
															<td>{ u.lastName }</td>
															<td>{ u.firstName }</td>
															<td>{ u.username }</td>
														</tr>
													))
												}
												</tbody>
											</table>
										}
										</div>
									</li>
								</ul>
							</div>
						)
					}
				</div>
			</ClickAwayListener>
		);
	}
);
